import { Routes } from '@angular/router';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  CemeterySiteDetailsComponentConfig,
  CemeterySiteDetailsSectionComponent
} from '../common/cemetery-site-details-section/cemetery-site-details-section.component';

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Dane miejsca na cmentarzu',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../dane-miejsca',
  cancelUrl: '../wnioskodawca',
  hideDocumentReceiptMethodControl: true
};

export const cemeterySiteDetailsSectionConfig: CemeterySiteDetailsComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../dane-wniosku',
  addPersonDataControls: true
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../dane-miejsca',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const applicationForACemeterySpaceRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: CemeterySiteDetailsSectionComponent,
    path: ':appId/dane-miejsca',
    data: cemeterySiteDetailsSectionConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
